import { client } from '../client';
import { UserProfile } from './types/UserProfile';

type UpdateOrganizationPayload = {
  organization_ids: string[];
};

export const updateUserOrganization = async (
  user_id: number,
  payload: UpdateOrganizationPayload,
  userRole?: string,
): Promise<UserProfile> => {
  const prefix =
    userRole === 'CareAdvisor' ? '/care_advisor' : userRole === 'Collector' ? '/collector' : '/admin';
  const { data } = await client.patch(`${prefix}/users/${user_id}/organizations`, payload);

  return data;
};
